

const Loader = () => {
    return (
      <div className="loader-block">
        <span className="loader"></span>
      </div>
    );
}

export default Loader;
